import { startRuntimeConfig } from './scripts/utilsRuntime';

// Host configuration for runtime module federation
// @ts-expect-error
window.hostConfig = {
  podName: process.env.REACT_APP_POD_NAME,
  hostName: 'web-app',
  version: process.env.REACT_APP_COMMIT_HASH,
  remotes: {
    base: process.env.REACT_APP_REMOTES_BASE,
  },
  datadog: {
    applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID,
    clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
  },
};

// Load config and initialize
(async () => {
  await startRuntimeConfig();
  await import('./App');
})().catch((error) => {
  // Fallback: if runtime config fails, import App anyway
  // UINEXT_REMOTES should have been set by startRuntimeConfig fallback logic
  // eslint-disable-next-line no-console
  console.error('Error during runtime config initialization:', error);
  import('./App');
});
